import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getOperationCode,
  getProductCallPrice,
  getProductPriceValue,
  getProductSourceKey,
  getProductTitle,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (state) => ({
  'Click Name': 'open popup tripadvisor',
  'Lowest Price': getProductCallPrice(state),
  'Operation Code': getOperationCode(state),
  'Product': getProductTitle(state),
  'Product Family ID': getProductSourceKey(state),
  'Product Price': getProductPriceValue(state),
  'Under Universe': getSubUniverseName(state),
  'Universe': getUniverseName(state)
})

const clickReviewsOpenTrackingEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.reviews.REVIEWS_OPEN),
  tap(action => {
    const eventName = 'Click'

    track(eventName, mapStateToMPEvent(state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickReviewsOpenTrackingEpic
